import axios from 'axios'
import { Message, MessageBox, Loading } from 'element-ui'
import { getStorage, removeStorage } from '@/utils/storage'

let loadingInit = null
const baseURL = process.env.BASE_API
// const baseURL = 'http://113.87.158.220:18820/zq-admin'

const service = axios.create({
  baseURL,
  timeout: 30000
})

service.interceptors.request.use( // 请求拦截器
  config => { // 请求前拦
    if (config.loading) {
      loadingInit = Loading.service({
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
    }
    if (config.method === 'get') config.params = JSON.parse(JSON.stringify(config.data))

    const token = getStorage('token') || ''
    if (token) config.headers['token'] = sessionStorage.getItem("token") ? sessionStorage.getItem("token") : token
    // config.headers["content-type"] = 'multipart/form-data;'
    config.transformResponse = [ // 返回数据处理
      data => {
        return JSON.parse(data)
      }
    ]

    return config
  },
  error => { // do something with request error
    console.log('请求异常：', error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use( // 响应拦截器
  response => {
    if (loadingInit) loadingInit.close()
    const res = response.data
    if (res.code == 0) return res
    else if (res.code == 400) {
      removeStorage()
      MessageBox.confirm(`登录超时，请重新登录！`, {
        type: 'error',
        showCancelButton: false
      }).then(() => {
        window.history.go(0)
      }).catch(action => {
        window.history.go(0)
      })
      return Promise.reject(new Error(res.msg))
    } else {
      Message({
        message: res.msg || '未知错误，请联系管理员！',
        type: 'error',
        duration: 2000
      })
      return Promise.reject(new Error(res.msg))
    }
  },
  error => {
    console.log(console)
    if (loadingInit) loadingInit.close()
    Message({
      message: '服务器繁忙，请稍后尝试！',
      type: 'error',
      duration: 2000
    })
    return Promise.reject(error)
  }
)
export default service

function request(url, data = {}, loading = true, method = 'post') {
  return service({ url, data, loading, method })
}

export {
  request
}



// WEBPACK FOOTER //
// ./src/utils/request.js